import React from 'react';

export default () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 13.8824V5.64706C17 4.74118 16.2588 4 15.3529 4H4.64706C3.74118 4 3 4.74118 3 5.64706V13.8824C3 14.7882 3.74118 15.5294 4.64706 15.5294H15.3529C16.2588 15.5294 17 14.7882 17 13.8824ZM7.94118 13.0588V6.47059L12.8824 9.76471L7.94118 13.0588Z" fill="currentColor" />
  </svg>
);
